import React from 'react';
import PropTypes from 'prop-types';
import PageHeader from '~app/components/Survey/PageHeader';
import QuizResultQuestion from '~app/components/Survey/QuizResultQuestion';

const SurveyPage = props => {
  const { page, totalPages, pageIndex, survey } = props;
  const getPageQuestions = questions => {
    return (
      <>
        {questions.map(item => {
          const { question } = item;
          return <QuizResultQuestion question={question} key={question.id} />;
        })}
      </>
    );
  };

  return (
    <section className="sm-survey-page--container" data-testid="SurveyPage__Container">
      <PageHeader currentPage={pageIndex + 1} totalPages={totalPages} />
      {getPageQuestions(survey[page.id])}
    </section>
  );
};

SurveyPage.propTypes = {
  page: PropTypes.shape({
    id: PropTypes.string,
    heading: PropTypes.string,
  }),
  survey: PropTypes.shape({}),
  pageIndex: PropTypes.number,
  totalPages: PropTypes.number,
};

SurveyPage.defaultProps = {
  page: null,
  survey: null,
  pageIndex: undefined,
  totalPages: undefined,
};

export default SurveyPage;
